import { ContentCard } from '../../components/ContentCard/ContentCard';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { Link } from 'react-router-dom';
import { ApiBonus, ApiOrderSummary } from '../../types';
import './OrderCard.css';

type OrderCardProps = {
	className?: string;
	order: ApiOrderSummary | ApiBonus;
};
export const OrderCard = ({ order }: OrderCardProps) => {
	const { asPrice, dateTimeFormat } = useFormatting();
	const t = useTranslation().orderPages;
	const bonusPage = useTranslation().bonusPage;
	const tRoutes = useTranslation().routes;

	if ('delivery' in order) {
		return (
			<ContentCard className="order-card">
				<Link
					to={{
						pathname: `${tRoutes.yourOrders}/${order.id}`,
						state: { displayId: order.displayId },
					}}
				>
					<div className="flex space-between">
						<p>
							<span className="bold">{t.orderNumber}:</span> {order.displayId}{' '}
						</p>
						<p className="date">{dateTimeFormat(new Date(order.datePurchased))}</p>
					</div>
					<hr />
					<div className="order-group">
						<p className="label">{t.recipient}</p>
						<p>
							{order.delivery.firstname} {order.delivery.lastname}, {order.delivery.city}
						</p>
					</div>
					<div className="order-group">
						<p className="label">{t.orderValue}</p>
						<p className="bold"> {asPrice(order.totals)}</p>
					</div>
					<div>
						<p className="label">{t.status}</p>
						<p>{t.visibleOrderStatus[order.status.id]}</p>
					</div>
				</Link>
			</ContentCard>
		);
	}

	return (
		<ContentCard className="order-card">
			<div className="flex space-between">
				<p>
					<span className="bold">{t.orderNumber}:</span> {order.orderId}{' '}
				</p>
				<p className="date">{dateTimeFormat(new Date(order.dateCreated))}</p>
			</div>
			<hr />
			<div className="flex space-between">
				<p className="label">{t.amount}</p>
				{<p className="label">{bonusPage.bonus}</p>}
				{<p className="label">{bonusPage.bonusLeft}</p>}
			</div>
			<div className="flex space-between  order-group">
				<p className="flex-basis-100">{asPrice(order.amount)}</p>
				{<p className="flex-basis-100">{asPrice(order.amountLeft)}</p>}
				<p className="flex-basis-100">{order.subTotal > 0 ? asPrice(order.subTotal) : ''}</p>
			</div>
			<p className="label">{bonusPage.expirationDate}</p>
			<p>{dateTimeFormat(new Date(order.dateExpires), true)}</p>
		</ContentCard>
	);
};
